import {
  Button,
  Confirm,
  Dimmer,
  Dropdown,
  Form,
  Loader,
} from 'semantic-ui-react';
import React, { useEffect } from 'react';
import { compose, graphql, withApollo } from 'react-apollo';

import Messages from '../Messages';
import PermissionsManager from '../PermissionsManager';
import getGuides from '../../apollo/graphql/guide/getAll';
import { inlineStyle } from '../../styles/custom';
import { languages } from '../../constants';

const AudioGuideSelector = ({
  obj,
  onChange,
  getGuides
}) => {
  const renderAudioGuides = (guides) => {
    return !guides.length
      ? [{ value: null, text: '--' }]
      : guides.map((guide) => {
        const title = guide.details.find(detail => detail.language_code === 'fr').title;
        return {
          value: guide.id,
          text: title,
        }
      });
  };

  useEffect(() => {
    getGuides.refetch();
  }, []);

  if (getGuides.loading)
    return (
      <Dimmer active inverted>
        <Loader inverted>Chargement</Loader>
      </Dimmer>
    );
    
  if (getGuides.error) {
    return <Messages errors={[getGuides.error]} />

  }
  return (

          <Form.Field>
            <label>Selectionnez un audio guide (obligatoire)</label>
            <Dropdown
              fluid
              selection
              closeOnChange
              id="guide_id"
              placeholder="Audio Guide"
              value={obj.guide_id}
              required
              options={renderAudioGuides(
                getGuides.getGuides
              )}
              onChange={(event, data) => onChange(event, data, 'dropdown')}
            />
          </Form.Field>
      
  );
};

export default withApollo(compose(
  graphql(getGuides, { name: 'getGuides' }))(AudioGuideSelector));



// WEBPACK FOOTER //
// ./src/components/form/AudioGuideSelector.js